import * as z from "zod"

// Schema para criação de setor baseado na API
export const sectorFormSchema = z.object({
  nome_setor: z.string().min(1, "Nome do setor é obrigatório").min(3, "Nome deve ter pelo menos 3 caracteres"),
  chefe_setor_fk: z.string().optional(), // Opcional, pode não ter chefe definido
  cidade_fk: z.string().min(1, "Cidade é obrigatória"),
  setor_fk: z.string().optional(), // Setor superior opcional
})

export type SectorFormValues = z.infer<typeof sectorFormSchema>

// Schema para a API request
export const createSetorRequest = z.object({
  nome_setor: z.string(),
  chefe_setor_fk: z.number().optional(),
  cidade_fk: z.number(),
  setor_fk: z.number().optional(),
})

export type CreateSetorRequest = z.infer<typeof createSetorRequest>
